import { MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
import { serviceAreas, serviceAreaIntro, business } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { CallButton } from "@/components/CallButton";
import { ContactCTA } from "@/components/home/ContactCTA";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export default function ServiceAreas() {
  return (
    <>
      <Seo
        title="Service Areas — Norwalk & Southern California"
        description="Velasco Lock and Safe is based in Norwalk, CA and serves surrounding Southern California communities including Downey, Long Beach, Los Angeles, Montebello and more. Call to confirm availability."
        path="/service-areas"
      />
      <PageHero
        overline="Service Areas"
        title="Serving Norwalk & Southern California"
        description={serviceAreaIntro}
      />

      <section className="bg-ink py-24 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <RevealGroup className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {serviceAreas.map((c) => (
              <RevealItem key={c}>
                <div
                  data-testid={`area-${c.toLowerCase().replace(/\s+/g, "-")}`}
                  className={cn(
                    "flex items-center gap-3 border p-5 transition-colors duration-300",
                    c === business.city
                      ? "border-gold bg-gold/10"
                      : "border-white/10 bg-ink-surface hover:border-gold/40",
                  )}
                >
                  <MapPin
                    className={cn(
                      "h-5 w-5 shrink-0",
                      c === business.city ? "text-gold" : "text-steel",
                    )}
                  />
                  <span
                    className={cn(
                      "font-heading font-bold",
                      c === business.city ? "text-gold" : "text-white",
                    )}
                  >
                    {c}
                  </span>
                  {c === business.city && (
                    <span className="ml-auto text-[10px] font-bold uppercase tracking-wider text-gold">
                      Base
                    </span>
                  )}
                </div>
              </RevealItem>
            ))}
          </RevealGroup>

          <div className="mt-12 border border-white/10 bg-ink-surface p-8 text-center">
            <p className="mx-auto max-w-2xl leading-relaxed text-steel">
              Don't see your city? We regularly travel throughout the region for the right
              job — especially specialized safe work. Because availability can vary by
              project, the best step is to call and confirm we can reach you.
            </p>
            <div className="mt-6 flex justify-center">
              <CallButton size="lg" showNumber testid="areas-call-btn" />
            </div>
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
